"use client";

import { useState } from "react";
import { fullAddress, mapsEmbedUrl, mapsSearchUrl } from "@/lib/site";
import { IconPin } from "./Icons";

/**
 * Google Maps dengan pola "facade": iframe pihak ketiga baru dimuat setelah
 * pengguna menekan tombol, sehingga tidak membebani performa halaman dan
 * tidak memasang cookie pihak ketiga sebelum ada interaksi.
 */
export function MapEmbed() {
  const [show, setShow] = useState(false);
  return (
    <div className="map-box">
      {show ? (
        <iframe
          src={mapsEmbedUrl}
          title={`Peta lokasi Ranutama Teknik Indonesia — ${fullAddress}`}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      ) : (
        <div className="map-facade">
          <svg className="map-pattern" viewBox="0 0 400 240" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid slice">
            <rect width="400" height="240" fill="#e7eef7" />
            <path d="M0 160 L400 120 M60 0 L140 240 M260 0 L230 240 M0 60 L400 80" stroke="#fff" strokeWidth="14" />
            <path d="M0 200 Q200 170 400 210" stroke="#cfdcea" strokeWidth="8" fill="none" />
            <circle cx="200" cy="112" r="18" fill="#0f1c38" />
            <circle cx="200" cy="112" r="7" fill="#fff" />
          </svg>
          <div className="map-facade-content">
            <p className="map-address">
              <IconPin size={18} /> {fullAddress}
            </p>
            <div className="map-actions">
              <button type="button" className="btn btn-primary" onClick={() => setShow(true)}>
                Tampilkan peta interaktif
              </button>
              <a className="btn btn-outline" href={mapsSearchUrl} target="_blank" rel="noopener noreferrer">
                Buka di Google Maps
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
